import {
  CreditCardIcon,
  IdentificationIcon,
  ShieldCheckIcon,
  DocumentTextIcon,
  MapIcon,
  UserGroupIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import { useState } from 'react';

export default function RentalRequirements() {
  const requirements = [
    {
      icon: CreditCardIcon,
      title: "Valid Credit Card",
      desc: "We require a valid credit card in the renter's name for security deposit.",
    },
    {
      icon: IdentificationIcon,
      title: "Driver's License",
      desc: "Must present a valid driver's license that’s been held for at least 2 years.",
    },
    {
      icon: ShieldCheckIcon,
      title: "Insurance Coverage",
      desc: "Proof of personal auto insurance that covers rental vehicles is required.",
    },
  ];

  return (
    <section id="rental-requirements" className="py-16 bg-brandBlue font-sans">
      <div className="max-w-7xl mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-12" data-aos="fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            Rental Requirements
          </h2>
          <p className="mt-4 text-lg text-blue-100 max-w-2xl mx-auto">
            Please review our requirements before booking to ensure a smooth rental experience.
          </p>
        </div>

        {/* Requirements Grid */}
        <div className="grid gap-8 md:grid-cols-3">
          {requirements.map((req, i) => (
            <div
              key={i}
              className="bg-blue-700 rounded-lg shadow hover:shadow-lg transition-all duration-500 p-6 text-center"
              data-aos="fade-up"
              data-aos-delay={i * 150}
            >
              <div className="flex items-center justify-center mb-3">
                <req.icon className="w-7 h-7 text-white mr-2" />
                <h3 className="text-lg font-semibold text-white">{req.title}</h3>
              </div>
              <p className="text-white">{req.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="/rental-policies"
            className="px-6 py-3 bg-white text-brandBlue font-semibold rounded shadow hover:bg-blue-100 transition"
          >
            View Full Rental Policies
          </a>
        </div>
        
      </div>
    </section>
  );
}